// hooks/useActiveSpaceData.hook.js
import { useSelector } from "react-redux";

export const useActiveSpaceData = (spaceId) => {
  const spaceData = useSelector((state) => state.space.spaceData) || [];
  const historySpaceId = useSelector((state) => state.history.spaceId);

  const activeSpaceId = spaceId || historySpaceId;

  return spaceData.find((space) => space.spaceId === activeSpaceId);
};
